import type { ThemeItem } from '../../../core/domain'

interface WonderGroup {
  fact: string
  names: string[]
}

const wonderGroups: WonderGroup[] = [
  {
    fact: 'Mountain or volcano: a landmark shaped by tectonic uplift or volcanic activity.',
    names: [
      'Mount Everest',
      'K2',
      'Kangchenjunga',
      'Lhotse',
      'Makalu',
      'Cho Oyu',
      'Denali',
      'Aconcagua',
      'Mount Kilimanjaro',
      'Mount Kenya',
      'Rwenzori Mountains',
      'Matterhorn',
      'Mont Blanc',
      'Eiger',
      'Mount Elbrus',
      'Table Mountain',
      'Mount Fuji',
      'Mount Kinabalu',
      'Puncak Jaya',
      'Mauna Kea',
      'Mauna Loa',
      'Kilauea',
      'Mount Vesuvius',
      'Mount Etna',
      'Stromboli',
      'Mount Teide',
      'Mount Pinatubo',
      'Mayon Volcano',
      'Mount Bromo',
      'Krakatoa',
      'Mount Rinjani',
      'Mount Tambora',
      'Mount Merapi',
      'Mount Kelimutu',
      'Mount Aso',
      'Aoraki / Mount Cook',
      'Mount Taranaki',
      'Mount Kosciuszko',
      'Mount Rainier',
      'Mount St. Helens',
      'Mount Shasta',
      'Grand Teton',
      'Mount Whitney',
      'Pico de Orizaba',
      'Popocatepetl',
      'Cotopaxi',
      'Chimborazo',
      'Torres del Paine',
      'Fitz Roy',
      'Vinicunca'
    ]
  },
  {
    fact: 'Waterfall: a place where a river or stream drops abruptly across resistant terrain.',
    names: [
      'Angel Falls',
      'Victoria Falls',
      'Iguazu Falls',
      'Niagara Falls',
      'Yosemite Falls',
      'Tugela Falls',
      'Kaieteur Falls',
      'Sutherland Falls',
      'Dettifoss',
      'Gullfoss',
      'Godafoss',
      'Seljalandsfoss',
      'Skogafoss',
      'Rhine Falls',
      'Krimml Waterfalls',
      'Gavarnie Falls',
      'Ban Gioc-Detian Falls',
      'Huangguoshu Waterfall',
      'Jog Falls',
      'Dudhsagar Falls',
      'Nohkalikai Falls',
      'Kuang Si Falls',
      'Erawan Falls',
      'Tad Fane Waterfall',
      'Shomyo Falls',
      'Nachi Falls',
      'Kegon Falls',
      'Thi Lo Su Waterfall',
      'Gitgit Waterfall',
      'Sekumpul Waterfall',
      'Tumpak Sewu',
      'Sipiso-piso',
      'Pagsanjan Falls',
      'Tinago Falls',
      'Blue Nile Falls',
      'Epupa Falls',
      'Augrabies Falls',
      'Maletsunyane Falls',
      'Ouzoud Falls',
      'Wli Waterfalls',
      'Murchison Falls',
      'Kalambo Falls',
      'Lumangwe Falls',
      'Gocta Cataracts',
      'Yumbilla Falls',
      'Salto Grande',
      'Havasu Falls',
      'Multnomah Falls',
      'Bridalveil Fall',
      'Wallaman Falls'
    ]
  },
  {
    fact: 'Rock landscape: a canyon, cliff or formation sculpted by erosion and geologic time.',
    names: [
      'Grand Canyon',
      'Fish River Canyon',
      'Colca Canyon',
      'Copper Canyon',
      'Tara River Canyon',
      'Verdon Gorge',
      'Samaria Gorge',
      'Vikos Gorge',
      'Blyde River Canyon',
      'Three Gorges',
      'Tiger Leaping Gorge',
      'Kali Gandaki Gorge',
      'Antelope Canyon',
      'Bryce Canyon',
      'Zion Canyon',
      'Canyonlands',
      'Monument Valley',
      'Arches National Park',
      'Devils Tower',
      "Giant's Causeway",
      'Cliffs of Moher',
      'White Cliffs of Dover',
      'Twelve Apostles',
      'Bungle Bungle Range',
      'Uluru',
      'Kata Tjuta',
      'The Wave, Arizona',
      'Zhangjiajie Sandstone Pillars',
      'Guilin Karst',
      'Tsingy de Bemaraha',
      'Ennedi Plateau',
      "Tassili n'Ajjer",
      'Wadi Rum',
      'Danxia Landform',
      'Chocolate Hills',
      'Cappadocia Fairy Chimneys',
      'Meteora',
      'Externsteine',
      'Saxon Switzerland',
      'Adrspach-Teplice Rocks',
      'Belogradchik Rocks',
      'Pobiti Kamani',
      'Valle de la Luna, Chile',
      'Quebrada de Humahuaca',
      'Rainbow Mountains of Zhangye',
      'Organ Pipes National Park',
      'Wave Rock',
      'Stone Forest of Shilin',
      'Lena Pillars',
      'Durdle Door'
    ]
  },
  {
    fact: 'Cave: a natural underground chamber formed in rock, ice or solidified lava.',
    names: [
      'Son Doong Cave',
      'Mammoth Cave',
      'Carlsbad Caverns',
      'Waitomo Glowworm Caves',
      'Skocjan Caves',
      'Postojna Cave',
      'Eisriesenwelt',
      'Jeita Grotto',
      'Reed Flute Cave',
      'Deer Cave',
      'Clearwater Cave System',
      'Puerto Princesa Underground River',
      'Phong Nha Cave',
      'Paradise Cave, Vietnam',
      'Blue Grotto, Capri',
      'Grotta Gigante',
      'Cave of Altamira',
      'Lascaux Cave',
      'Chauvet Cave',
      'Cave of the Crystals',
      'Dos Ojos Cenote',
      'Actun Tunichil Muknal',
      'Cango Caves',
      'Sterkfontein Caves',
      'Sudwala Caves',
      'Melissani Cave',
      'Dikteon Cave',
      'Marble Caves of Chile',
      'Batu Caves',
      'Gomantong Caves',
      'Niah Caves',
      'Jenolan Caves',
      'Naracoorte Caves',
      'Buchan Caves',
      'Oregon Caves',
      'Luray Caverns',
      'Kartchner Caverns',
      'Lechuguilla Cave',
      'Wind Cave',
      'Jewel Cave',
      'Lava Beds Lava Tubes',
      'Kazumura Cave',
      'Ape Cave',
      "Fingal's Cave",
      'Sea Lion Caves',
      'Blue Grotto, Malta',
      'Cave of Swallows',
      'Majlis al Jinn',
      'Al Hoota Cave',
      "Devil's Cave, Germany"
    ]
  },
  {
    fact: 'Desert: an arid landscape where wind, salt and scarce water create distinctive terrain.',
    names: [
      'Sahara Desert',
      'Namib Desert',
      'Kalahari Desert',
      'Atacama Desert',
      'Gobi Desert',
      'Arabian Desert',
      'Rub al Khali',
      'Thar Desert',
      'Taklamakan Desert',
      'Karakum Desert',
      'Kyzylkum Desert',
      'Great Victoria Desert',
      'Great Sandy Desert',
      'Simpson Desert',
      'Gibson Desert',
      'Mojave Desert',
      'Sonoran Desert',
      'Chihuahuan Desert',
      'Patagonian Desert',
      'Antarctic Polar Desert',
      'Arctic Polar Desert',
      'Dasht-e Kavir',
      'Dasht-e Lut',
      'Negev Desert',
      'White Desert, Egypt',
      'Black Desert, Egypt',
      'Danakil Depression',
      'Makgadikgadi Pans',
      'Salar de Uyuni',
      'Salar de Atacama',
      'Sossusvlei',
      'Deadvlei',
      'Skeleton Coast',
      'Erg Chebbi',
      'Erg Chigaga',
      'Tadrart Rouge',
      'Richat Structure',
      'Lencois Maranhenses',
      'Mesquite Flat Sand Dunes',
      'White Sands',
      'Great Sand Dunes',
      'Kelso Dunes',
      'Algodones Dunes',
      'Badain Jaran Desert',
      'Singing Sand Dunes of Dunhuang',
      'Pinnacles Desert',
      'Bardenas Reales',
      'Tabernas Desert',
      'Bisti Badlands',
      'Painted Desert'
    ]
  },
  {
    fact: 'Inland water: a lake, river or wetland sustained by a distinctive hydrologic system.',
    names: [
      'Lake Baikal',
      'Lake Superior',
      'Lake Victoria',
      'Lake Tanganyika',
      'Lake Malawi',
      'Lake Titicaca',
      'Great Bear Lake',
      'Great Slave Lake',
      'Lake Ladoga',
      'Lake Onega',
      'Lake Geneva',
      'Lake Como',
      'Lake Bled',
      'Lake Ohrid',
      'Plitvice Lakes',
      'Peyto Lake',
      'Lake Louise',
      'Moraine Lake',
      'Crater Lake',
      'Lake Tahoe',
      'Great Salt Lake',
      'Lake Natron',
      'Lake Turkana',
      'Lake Assal',
      'Dead Sea',
      'Caspian Sea',
      'Tonle Sap',
      'Inle Lake',
      'Lake Toba',
      'Jiuzhaigou Lakes',
      'Lake Hillier',
      'Lake Retba',
      'General Carrera Lake',
      'Nahuel Huapi Lake',
      'Lake Atitlan',
      'Lake Nicaragua',
      'Lake Maracaibo',
      'Amazon River',
      'Nile River',
      'Congo River',
      'Okavango Delta',
      'Pantanal',
      'Everglades',
      'Danube Delta',
      'Camargue Wetlands',
      'Cano Cristales',
      'Soca River',
      'Li River',
      'Mekong Delta',
      'Lena River Delta'
    ]
  },
  {
    fact: 'Island or coast: a shoreline landscape shaped by waves, tides and isolation.',
    names: [
      'Galapagos Islands',
      'Maldives',
      'Seychelles',
      'Socotra',
      'Madagascar',
      'Borneo',
      'Komodo Island',
      'Raja Ampat Islands',
      'Palawan',
      'Jeju Island',
      'Yakushima',
      'Ha Long Bay',
      'Phang Nga Bay',
      'Phi Phi Islands',
      'Andaman Islands',
      'Nicobar Islands',
      'Mauritius',
      'Reunion Island',
      'Zanzibar',
      'Fernando de Noronha',
      'Easter Island',
      'Hawaiian Islands',
      'Na Pali Coast',
      'Big Sur Coast',
      'Amalfi Coast',
      'Algarve Coast',
      'Lofoten Islands',
      'Faroe Islands',
      'Svalbard',
      'Greenland',
      'Iceland',
      'Isle of Skye',
      'Staffa',
      'Capri',
      'Santorini Caldera',
      'Azores',
      'Madeira',
      'Canary Islands',
      'Aeolian Islands',
      'Dalmatian Coast',
      'Bay of Fundy',
      'Haida Gwaii',
      'Aleutian Islands',
      'Kuril Islands',
      "K'gari",
      'Whitsunday Islands',
      'Milford Sound',
      'Doubtful Sound',
      'Bay of Islands',
      'Abel Tasman Coast'
    ]
  },
  {
    fact: 'Forest or plain: a broad living landscape defined by its climate and plant communities.',
    names: [
      'Amazon Rainforest',
      'Congo Rainforest',
      'Daintree Rainforest',
      'Bialowieza Forest',
      'Black Forest',
      'Redwood National and State Parks',
      'Giant Sequoia Groves',
      'Olympic Temperate Rainforest',
      'Hoh Rainforest',
      'Tongass National Forest',
      'Great Bear Rainforest',
      'Monteverde Cloud Forest',
      'El Yunque Rainforest',
      'Valdivian Temperate Rainforest',
      'Atlantic Forest',
      'Araucaria Forest',
      'Crooked Forest',
      "Socotra Dragon's Blood Forest",
      'Sundarbans Mangrove Forest',
      'Taiga',
      'Bwindi Impenetrable Forest',
      'Kibale Forest',
      'Nyungwe Forest',
      'Kakamega Forest',
      'Mau Forest Complex',
      'Madagascar Spiny Forest',
      'Serengeti Plains',
      'Maasai Mara',
      'Ngorongoro Crater',
      'Etosha Pan',
      'Mongolian Steppe',
      'Eurasian Steppe',
      'Pampas',
      'Cerrado',
      'Llanos',
      'Kruger Savanna',
      'Tibetan Plateau',
      'Altiplano',
      'Deosai Plains',
      'Scottish Highlands',
      'The Burren',
      'Joshua Tree Woodland',
      'Avenue of the Baobabs',
      'Borneo Peat Swamp Forest',
      'Congo Basin Peatlands',
      'Muir Woods',
      'Caledonian Forest',
      'Taman Negara',
      'Sinharaja Forest Reserve',
      'Kinabalu Cloud Forest'
    ]
  },
  {
    fact: 'Ice landscape: a glacier, ice sheet or frozen formation created by accumulated snow.',
    names: [
      'Antarctic Ice Sheet',
      'Greenland Ice Sheet',
      'Ross Ice Shelf',
      'Ronne-Filchner Ice Shelf',
      'Larsen C Ice Shelf',
      'Perito Moreno Glacier',
      'Upsala Glacier',
      'Grey Glacier',
      'Pio XI Glacier',
      'San Rafael Glacier',
      'Quelccaya Ice Cap',
      'Vatnajokull',
      'Jokulsarlon Glacier Lagoon',
      'Skaftafell Ice Caves',
      'Langjokull',
      'Myrdalsjokull',
      'Eyjafjallajokull',
      'Aletsch Glacier',
      'Mer de Glace',
      'Pasterze Glacier',
      'Jostedalsbreen',
      'Folgefonna',
      'Svartisen',
      'Nigardsbreen',
      'Austfonna',
      'Mendenhall Glacier',
      'Hubbard Glacier',
      'Columbia Glacier, Alaska',
      'Matanuska Glacier',
      'Exit Glacier',
      'Glacier Bay',
      'Athabasca Glacier',
      'Columbia Icefield',
      'Peyto Glacier',
      'Saskatchewan Glacier',
      'Illecillewaet Glacier',
      'Franz Josef Glacier',
      'Fox Glacier',
      'Tasman Glacier',
      'Hooker Glacier',
      'Baltoro Glacier',
      'Biafo Glacier',
      'Hispar Glacier',
      'Siachen Glacier',
      'Gangotri Glacier',
      'Khumbu Glacier',
      'Ngozumpa Glacier',
      'Fedchenko Glacier',
      'Inylchek Glacier',
      'Lambert Glacier'
    ]
  },
  {
    fact: 'Oceanic or geothermal wonder: a feature powered by oceans, Earth heat or the atmosphere.',
    names: [
      'Great Barrier Reef',
      'Belize Barrier Reef',
      'Red Sea Coral Reef',
      'New Caledonia Barrier Reef',
      'Ningaloo Reef',
      'Tubbataha Reefs',
      'Apo Reef',
      'Florida Reef',
      'Andros Barrier Reef',
      'Aldabra Atoll',
      'Bikini Atoll',
      'Rock Islands Southern Lagoon',
      'Blue Hole of Dahab',
      "Dean's Blue Hole",
      'Great Blue Hole',
      'Mariana Trench',
      'Tonga Trench',
      'Puerto Rico Trench',
      'Mid-Atlantic Ridge',
      'East Pacific Rise',
      'Lost City Hydrothermal Field',
      'Sargasso Sea',
      'Mosquito Bay Bioluminescence',
      'Vaadhoo Bioluminescent Beach',
      'Sardine Run',
      'Yellowstone Caldera',
      'Grand Prismatic Spring',
      'Old Faithful',
      'Mammoth Hot Springs',
      'Rotorua Geothermal Area',
      'Wai-O-Tapu',
      'Waimangu Volcanic Rift Valley',
      'Geysir',
      'Strokkur',
      'Hverir',
      'Valley of Geysers',
      'El Tatio',
      'Sol de Manana',
      'Pamukkale',
      'Dallol Hydrothermal Field',
      'Champagne Pool',
      'Lassen Hydrothermal Area',
      'Aurora Borealis',
      'Aurora Australis',
      'Catatumbo Lightning',
      'Morning Glory Cloud',
      'Hessdalen Lights',
      'Sailing Stones of Racetrack Playa',
      'Pororoca Tidal Bore',
      'Horizontal Falls'
    ]
  }
]

export const NATURAL_WONDER_ITEMS: ThemeItem[] = wonderGroups.flatMap(({ fact, names }) =>
  names.map((name) => ({
    name,
    imageUrl: null,
    fact,
    sourceId: 'wikipedia-search',
    sourcePath: name
  }))
)

if (
  wonderGroups.some((group) => group.names.length !== 50) ||
  NATURAL_WONDER_ITEMS.length !== 500 ||
  new Set(NATURAL_WONDER_ITEMS.map((item) => item.name)).size !== 500
) {
  throw new Error('The natural wonders theme must contain ten groups of 50 unique entries.')
}
